import type { ResourceTypeHandle } from '@toolproof-core/genesis/_contract/_index';
import type { SpaceAdapter } from '@toolproof-core/visualization/adapter/_contract/adapter';

import { createStructureLoader, loadProteinStructure } from '@/adapters/biology/loadProteinStructure';
import { DEFAULT_STRUCTURE_ID, biologyStructureEntry } from '@/adapters/biology/_data/structures';
import { buildCosmosData } from '@/adapters/biology/_pure/cosmosData';
import { RESOURCE_TYPE_REQUIREMENTS } from '@/adapters/biology/_pure/resourceTypeInputSpec';
import { runtimeController } from '@/adapters/biology/_pure/runtimeController';
import { createSpaceDeriver } from '@/adapters/biology/framePipeline';
import { SPACE_KEY } from '@/adapters/biology/spaceIdentity';
import type { SpaceAdapterDescriptor } from '@/_contract/types';
import type { CosmosDataModel, Config, RuntimeState } from '@/adapters/biology/_contract/config';

const CONFIG: Config = {};

const spaceAdapter: SpaceAdapter<ResourceTypeHandle, CosmosDataModel, Config, RuntimeState> = {
    createSpaceDeriver,
};

export const DESCRIPTOR = {
    baseDescriptor: {
        spaceKey: SPACE_KEY,
        adapter: spaceAdapter,
        getResourceTypeInputSpec: () => ({ requiredResourceTypes: RESOURCE_TYPE_REQUIREMENTS }),
        buildCosmosData,
        defaultConfig: CONFIG,
    },
    runtime: {
        kind: 'single',
        controller: runtimeController,
    },
    loadSupplementalCosmosData: async (_config: Config, signal: AbortSignal) => ({
        proteinStructure: await loadProteinStructure(biologyStructureEntry(DEFAULT_STRUCTURE_ID)!, signal),
    }),
    createRuntimeEffectOwner: createStructureLoader,
} as const satisfies SpaceAdapterDescriptor<ResourceTypeHandle, CosmosDataModel, Config, RuntimeState>;

export type AdapterDescriptor = typeof DESCRIPTOR;
